(() => {
  const STYLE_ID = "nomna-cart-preview-style";
  const CART_PREVIEW_STORAGE_KEY = "nomna_custom_nails_cart_previews_v1";
  const DEFAULT_MEDIA_BASE = "https://nails-api.octopost.social";
  const PREVIEW_KEYS = ["_Preview image", "_AI preview image", "AI preview", "_AI preview"];
  const HIDDEN_LABELS = [
    "AI preview",
    "Preview image",
    "Nail type",
    "Local trial",
    "Preview reviewed",
    "AI preview disclaimer",
    "Nomna custom nail ID",
    "Nomna reference",
    "Nomna ref",
    "_Preview image",
    "_AI preview image",
    "_Custom design full",
    "_Full design brief",
    "_Nomna generation ID",
    "_Nomna reference",
    "_AI preview reviewed",
    "_AI preview disclaimer",
  ];
  const HIDDEN_PREFIXES = [
    "Reference image ",
    "Nomna reference image ",
    "Shopify file ",
    "_Reference image ",
    "_Shopify file ",
  ];
  const RENAME_LABELS = {
    "Custom nail prompt": "Custom design",
    "Custom design request": "Custom design",
    "Cat Eye style": "Magnetic beam",
    "Customer note": "Note",
  };
  let resolvedMediaBase = "";
  let applying = false;
  let observerStarted = false;
  let observerTimer = 0;

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = `
      img[data-nomna-cart-preview="true"] {
        object-fit: contain !important;
        background: #faf7f9 !important;
      }
      [data-nomna-preview-pending="true"] img:not([data-nomna-cart-preview="true"]) {
        opacity: 0 !important;
      }
    `;
    document.head.appendChild(style);
  }

  async function readCart() {
    try {
      const response = await window.fetch("/cart.js", {
        credentials: "same-origin",
        headers: { Accept: "application/json" },
      });
      if (!response.ok) return null;
      return await response.json();
    } catch {
      return null;
    }
  }

  function previewUrl(item) {
    const properties = item?.properties || {};
    for (const key of PREVIEW_KEYS) {
      const value = String(properties[key] || "").trim();
      if (value) return absoluteUrl(value);
    }
    return "";
  }

  function mediaBaseUrl() {
    if (resolvedMediaBase) return resolvedMediaBase;
    const script = document.currentScript ||
      Array.from(document.scripts).reverse().find((node) =>
        String(node.src || "").includes("/shopify-media/nomna-cart-preview.js")
      );
    try {
      const src = String(script?.src || "");
      resolvedMediaBase = src ? new URL(src, window.location.href).origin : DEFAULT_MEDIA_BASE;
    } catch {
      resolvedMediaBase = DEFAULT_MEDIA_BASE;
    }
    return resolvedMediaBase.replace(/\/$/, "");
  }

  function absoluteUrl(value) {
    value = String(value || "").trim();
    const rewritten = rewriteStorefrontMediaUrl(value);
    if (rewritten) return rewritten;
    if (/^https?:\/\//i.test(value)) return value;
    if (value.startsWith("//")) return `${window.location.protocol}${value}`;
    if (value.startsWith("/shopify-media")) return `${mediaBaseUrl()}${value}`;
    if (value.startsWith("/")) return `${window.location.origin}${value}`;
    return value;
  }

  function rewriteStorefrontMediaUrl(value) {
    if (!value || value.startsWith("data:")) return "";
    try {
      const parsed = new URL(value.startsWith("//") ? `${window.location.protocol}${value}` : value, window.location.href);
      if (!parsed.pathname.startsWith("/shopify-media")) return "";
      if (parsed.origin !== window.location.origin && parsed.hostname !== window.location.hostname) return "";
      return `${mediaBaseUrl()}${parsed.pathname}${parsed.search}${parsed.hash}`;
    } catch {
      return "";
    }
  }

  function cartRows() {
    const selectors = [
      "cart-items tr.cart-item",
      "form[action*='/cart'] tr.cart-item",
      "form[action*='/cart'] .cart-item",
      "#main-cart-items .cart-item",
      ".main-cart-items .cart-item",
      ".cart__items .cart-item",
      ".cart-item",
    ];
    const rows = [];
    selectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((node) => {
        if (!rows.includes(node) && node.querySelector("img")) rows.push(node);
      });
    });
    return rows;
  }

  function rowText(row) {
    return (row?.textContent || "").replace(/\s+/g, " ").trim();
  }

  function rowLooksCustom(row) {
    const text = rowText(row).toLowerCase();
    return text.includes("custom ai press-on nails") || text.includes("custom design:");
  }

  function propertyValue(item, keys) {
    const properties = item?.properties || {};
    for (const key of keys) {
      const value = String(properties[key] || "").replace(/\s+/g, " ").trim();
      if (value) return value;
    }
    return "";
  }

  function itemLooksCustom(item) {
    const title = String(item?.product_title || item?.title || item?.handle || "").toLowerCase();
    return Boolean(
      title.includes("custom ai press-on nails") ||
      propertyValue(item, ["Custom design", "Custom nail prompt", "Custom design request"]) ||
      propertyValue(item, ["_Nomna reference", "_Nomna generation ID", "Nomna custom nail ID"]) ||
      previewUrl(item)
    );
  }

  function customCartItems(items) {
    return (items || []).filter((item) => itemLooksCustom(item) && previewUrl(item));
  }

  function scoreCartItemForRow(row, item) {
    const text = rowText(row).toLowerCase();
    let score = rowLooksCustom(row) ? 2 : 0;
    [
      [item?.product_title || item?.title, 2],
      [propertyValue(item, ["Custom design", "Custom nail prompt", "Custom design request"]), 5],
      [propertyValue(item, ["Size"]), 2],
      [propertyValue(item, ["Shape"]), 2],
      [propertyValue(item, ["Magnetic beam", "Cat Eye style"]), 2],
      [propertyValue(item, ["_Nomna reference", "_Nomna generation ID", "Nomna custom nail ID"]), 6],
    ].forEach(([value, points]) => {
      const normalized = String(value || "").trim().toLowerCase();
      if (normalized && text.includes(normalized)) score += points;
    });
    return score;
  }

  function setPendingRows(pending) {
    cartRows().forEach((row) => {
      if (!rowLooksCustom(row)) return;
      if (pending) row.dataset.nomnaPreviewPending = "true";
      else delete row.dataset.nomnaPreviewPending;
    });
  }

  function setRowImage(row, url, item) {
    const image = row?.querySelector("img");
    if (!image || !url) return;
    image.src = url;
    image.removeAttribute("srcset");
    image.removeAttribute("sizes");
    image.alt = `AI preview for ${item?.product_title || item?.title || "custom nails"}`;
    image.dataset.nomnaCartPreview = "true";
    delete row.dataset.nomnaPreviewPending;
  }

  function replaceImages(items) {
    const itemsWithPreviews = customCartItems(items);
    if (!itemsWithPreviews.length) return;
    const customRows = cartRows().filter(rowLooksCustom);
    const rows = customRows.length ? customRows : cartRows().slice(0, itemsWithPreviews.length);
    const usedItems = new Set();
    rows.forEach((row, rowIndex) => {
      let bestIndex = -1;
      let bestScore = -1;
      itemsWithPreviews.forEach((item, itemIndex) => {
        if (usedItems.has(itemIndex)) return;
        const score = scoreCartItemForRow(row, item);
        if (score > bestScore) {
          bestIndex = itemIndex;
          bestScore = score;
        }
      });
      if ((bestIndex < 0 || bestScore <= 0) && itemsWithPreviews[rowIndex] && !usedItems.has(rowIndex)) {
        bestIndex = rowIndex;
      }
      const item = itemsWithPreviews[bestIndex];
      const url = previewUrl(item);
      if (!url) return;
      usedItems.add(bestIndex);
      setRowImage(row, url, item);
    });
  }

  function readStoredPreviews() {
    try {
      const raw = window.sessionStorage?.getItem(CART_PREVIEW_STORAGE_KEY);
      const list = JSON.parse(raw || "[]");
      if (!Array.isArray(list)) return [];
      const now = Date.now();
      return list
        .filter((entry) => entry && typeof entry === "object")
        .filter((entry) => String(entry.preview_url || "").trim())
        .filter((entry) => now - Number(entry.added_at || 0) < 24 * 60 * 60 * 1000);
    } catch {
      return [];
    }
  }

  function writeStoredPreviewsFromCart(items) {
    try {
      const previews = (items || [])
        .map((item) => {
          const url = previewUrl(item);
          if (!url) return null;
          const properties = item.properties || {};
          return {
            key: String(item.key || "").trim(),
            variant_id: String(item.variant_id || "").trim(),
            product_title: String(item.product_title || item.title || "").trim(),
            generation_id: String(properties["_Nomna reference"] || properties["_Nomna generation ID"] || "").trim(),
            preview_url: url,
            custom_design: String(properties["Custom design"] || "").trim(),
            size: String(properties.Size || "").trim(),
            shape: String(properties.Shape || "").trim(),
            magnetic_beam: String(properties["Magnetic beam"] || properties["Cat Eye style"] || "").trim(),
            added_at: Date.now(),
          };
        })
        .filter(Boolean);
      if (previews.length) {
        window.sessionStorage?.setItem(CART_PREVIEW_STORAGE_KEY, JSON.stringify(previews.slice(0, 12)));
      }
    } catch {
      // Storage is an optimization only.
    }
  }

  function scoreStoredPreview(row, preview) {
    const text = rowText(row).toLowerCase();
    let score = 0;
    [
      preview.product_title,
      preview.custom_design,
      preview.size,
      preview.shape,
      preview.magnetic_beam,
    ].forEach((value) => {
      const normalized = String(value || "").trim().toLowerCase();
      if (normalized && text.includes(normalized)) score += 1;
    });
    return score;
  }

  function replaceImagesFromStorage() {
    const previews = readStoredPreviews();
    if (!previews.length) return;
    const used = new Set();
    cartRows()
      .filter(rowLooksCustom)
      .forEach((row, index) => {
        let bestIndex = -1;
        let bestScore = -1;
        previews.forEach((preview, previewIndex) => {
          if (used.has(previewIndex)) return;
          const score = scoreStoredPreview(row, preview);
          if (score > bestScore) {
            bestIndex = previewIndex;
            bestScore = score;
          }
        });
        if (bestIndex < 0 && previews[index] && !used.has(index)) bestIndex = index;
        const preview = previews[bestIndex];
        if (!preview?.preview_url) return;
        used.add(bestIndex);
        setRowImage(row, absoluteUrl(String(preview.preview_url)), {
          product_title: preview.product_title,
        });
      });
  }

  function shouldHideLabel(label) {
    const normalized = String(label || "").trim();
    if (!normalized) return false;
    if (normalized.startsWith("_")) return true;
    const lower = normalized.toLowerCase();
    if (HIDDEN_LABELS.some((hidden) => lower === hidden.toLowerCase())) return true;
    return HIDDEN_PREFIXES.some((prefix) => lower.startsWith(prefix.toLowerCase()));
  }

  function cleanProperties() {
    const candidates = document.querySelectorAll(
      "main li, main p, main dd, main dt, main .product-option, main .cart-item__details div, main .cart-item__details span"
    );
    candidates.forEach((node) => {
      const text = (node.textContent || "").replace(/\s+/g, " ").trim();
      if (!text || text.length > 1200 || !text.includes(":")) return;
      const label = text.split(":")[0].trim();
      if (shouldHideLabel(label)) {
        node.hidden = true;
        node.style.display = "none";
        return;
      }
      const replacement = RENAME_LABELS[label];
      if (!replacement) return;
      const firstText = Array.from(node.childNodes).find((child) => child.nodeType === Node.TEXT_NODE);
      if (firstText && firstText.textContent.includes(label)) {
        firstText.textContent = firstText.textContent.replace(label, replacement);
      } else {
        node.textContent = text.replace(`${label}:`, `${replacement}:`);
      }
    });
  }

  async function applyCartPreview() {
    if (applying) return;
    applying = true;
    try {
      injectStyles();
      replaceImagesFromStorage();
      setPendingRows(true);
      cleanProperties();
      const cart = await readCart();
      if (cart?.items?.length) {
        replaceImages(cart.items);
        writeStoredPreviewsFromCart(cart.items);
        cleanProperties();
      }
      setPendingRows(false);
    } finally {
      applying = false;
    }
  }

  function scheduleCartPreview() {
    window.clearTimeout(observerTimer);
    observerTimer = window.setTimeout(applyCartPreview, 120);
  }

  function startCartObserver() {
    if (observerStarted || !document.body) return;
    observerStarted = true;
    const observer = new MutationObserver((mutations) => {
      if (!mutations.some((mutation) => mutation.addedNodes.length || mutation.removedNodes.length)) return;
      scheduleCartPreview();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      applyCartPreview();
      startCartObserver();
    }, { once: true });
  } else {
    applyCartPreview();
    startCartObserver();
  }
  document.addEventListener("shopify:section:load", applyCartPreview);
  document.addEventListener("cart:updated", applyCartPreview);
  window.setTimeout(applyCartPreview, 1200);
})();
